import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, of, switchMap } from 'rxjs';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';

import { ProceedButtonActions } from '@modules/booking/store/proceed-button/proceed-button.actions';
import { BookingScheduleAppointmentActions } from '@modules/booking/store/appointment';

@Injectable()
export class ProceedButtonEffects {
  constructor(private actions$: Actions) {}

  hideProceedButton$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATED),
      map(() => ProceedButtonActions.hide())
    );
  });

  showProceedButton$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(BookingScheduleAppointmentActions.componentLoaded),
      switchMap(() => of(ProceedButtonActions.display()))
    );
  });
}
